<template>
  <div>
    <div class="row">
      <div class="col-3">
        <combo-box-with-message
          :combo-list="countryList"
          itemKey="id"
          itemValue="title"
          :selectedItem="1"
          @comboOnChanged="countrySelected"
          topTitle="کشور : "
          :required="true"
          comboSize="sm"
          errorText="مقدار را درست انتخاب کنید."
        />
      </div>
      <div class="col-3">
        <date-time-picker
          :color="this.dateTimePickerEntity.color"
          :disable="false"
          :initialValue="this.dateTimePickerEntity.initialValue"
          initialValueType="en"
          :min="getPersianDate(this.dateTimePickerEntity.minDate)"
          :max="getPersianDate(this.dateTimePickerEntity.maxDate)"
          type="date"
          containerClass="mt-4"
          dateTimePickerClass=""
          placeholder="تاریخ مورد نظر را انتخاب نمایید"
          v-model:gregorianDate="this.dateTimePickerEntity.gregorianDate"
          v-model:jalaliDate="this.dateTimePickerEntity.jalaliDate"
          topTitle="تاریخ"
          :required="true"
          :clearable="true"
        />
        <div>jalali Date: {{ this.dateTimePickerEntity.jalaliDate }}</div>
        <div>gregorian Date: {{ this.dateTimePickerEntity.gregorianDate }}</div>
      </div>
      <div class="col-3">
        <check-box-with-message
          title="گزینه"
          color="#1b2a4e"
          :disabled="false"
          checkBoxClas=""
          containerClass=""
          :required="true"
          errorText="الزامی است"
          errorClass=""
          v-model:checkBoxValue="checkBoxValue"
          @checkboxOnChanged="checkboxOnChanged"
        />
        <span>checkbox value: {{ checkBoxValue }}</span>
      </div>

      <div class="col-3">
        <captcha></captcha>
      </div>
    </div>
    <hr class="bg-gradient-primary my-0 container" />
  </div>
</template>

<script>
import ComboBoxWithMessage from '../components/form/comboBoxWithMessage/ComboBoxWithMessage.vue';
import DateTimePicker from '../components/form/dateTimePicker/DateTimePicker.vue';
import CheckBoxWithMessage from '../components/form/checkBoxWithMessage/CheckBoxWithMessage.vue';
import Captcha from '../components/utility/captcha/Captcha.vue';
import axios from 'axios';
export default {
  components: {
    ComboBoxWithMessage,
    DateTimePicker,
    CheckBoxWithMessage,
    Captcha,
  },
  data() {
    return {
      countryList: [],
      dateTimePickerEntity: {
        initialValue: new Date(),
        minDate: new Date(),
        maxDate: new Date(),
        gregorianDate: '',
        jalaliDate: '',
        color: '#7b7ce6',
      },
      checkBoxValue: false,
    };
  },
  methods: {
    checkboxOnChanged(value) {
      alert(value);
    },
    async getCountryList() {
      let that = this.$data;
      //Get CountryList
      await axios
        .get(this.$store.state.apiBaseURL + '/Basic/Country')
        .then((response) => {
          that.countryList = response.data;
        });
    },
    countrySelected(id) {
      alert(id);
    },
    getPersianDate(date) {
      // eslint-disable-next-line
      return new persianDate(new Date(date)).toLocale('en').format('L');
    },
  },
  async beforeMount() {
    await this.getCountryList();
  },
};
</script>
